import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from '_public/templates/main/app.component';
import { AppService } from '_public/templates/main/app.service';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { TemplatePreviewComponent } from '_public/templates/main/template-preview/template-preview.component';
import { WindowRef } from 'admin/utile/services/WindowRef ';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
    declarations: [
        AppComponent,
        TemplatePreviewComponent
    ],
    entryComponents: [
        TemplatePreviewComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        HttpClientXsrfModule.withOptions({
            cookieName: 'XSRF-TOKEN',
            //headerName: 'My-Xsrf-Header',
        }),

		MatBottomSheetModule,

		NgxSpinnerModule
    ],
    providers: [
        AppService,
        WindowRef
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule
{
}
